import React from 'react';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import styled from 'styled-components';
import { getPriceWithSymbol } from 'utilities/price/price-utilities';
import { TypographyComponent as TypographyElement, Checkbox } from '@tvg/fuse-design';

const StyledTypography = styled(TypographyElement)`
  color: var(--color-global-black);
  margin-bottom: var(--spacing-space8);
`;

const AddonHeaderTypography = styled(TypographyElement)`
  color: var(--color-global-black);
  margin-bottom: var(--spacing-space16);
`;

const AddonContainer = styled.div`
  margin-bottom: var(--spacing-space16);

  .addon-container-item:nth-child(1) {
    display: block;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    order: 0;

    label {
      outline: none;
    }
  }

  .addon-container-item:nth-child(2) {
    display: block;
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    order: 0;

    label {
      outline: none;
    }
  }
`;

const AddonTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: normal;
  align-content: normal;

  .addon-title-item:nth-child(1) {
    display: block;
    flex-shrink: 1;
    order: 0;
  }

  .addon-title-item:nth-child(2) {
    display: block;
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    order: 0;
  }
`;

const AddonItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: normal;
  align-items: normal;
  align-content: normal;
`;

export function Addon() {
  const { filteredLinkedAddonServicesContent, handleLinkedAddonServiceSelectionChange } = useSelectedSkuContext();

  if (!filteredLinkedAddonServicesContent) {
    return null;
  }

  const lastIndex = filteredLinkedAddonServicesContent ? filteredLinkedAddonServicesContent.length - 1 : 0;

  if (filteredLinkedAddonServicesContent?.length > 0) {
    return (
      <>
        <AddonHeaderTypography tag="h3" size="1">
          + Optional services
        </AddonHeaderTypography>

        {filteredLinkedAddonServicesContent?.map((service, index) => (
          <AddonContainer>
            <div className="addon-container-item">
              <Checkbox
                isChecked={service.isSelected}
                onChange={() => {
                  handleLinkedAddonServiceSelectionChange(index);
                }}
                name={service.productId}
              >
                <AddonItemContainer>
                  <AddonTitleContainer>
                    <StyledTypography
                      size="1"
                      tag="p"
                      type="paragraph"
                      className="addon-title-item"
                      dataTestId="addon-item-title"
                    >
                      {service?.title}
                    </StyledTypography>
                    <StyledTypography size="1" tag="div" className="addon-title-item" dataTestId="addon-item-price">
                      {typeof service?.price?.now?.basePrice === 'number'
                        ? getPriceWithSymbol(service?.price?.now?.basePrice, service?.price?.now?.currencyCode)
                        : ''}
                    </StyledTypography>
                  </AddonTitleContainer>

                  <TypographyElement size="m1" tag="p" type="paragraph" dataTestId="addon-item-description">
                    {service?.description}
                  </TypographyElement>
                </AddonItemContainer>
              </Checkbox>
              {index === lastIndex && (
                <TypographyElement size="m2" tag="p" type="paragraph" dataTestId="addon-item-delivery-description">
                  Services may affect delivery dates.
                </TypographyElement>
              )}
            </div>
          </AddonContainer>
        ))}
      </>
    );
  }
  return null;
}

export default Addon;
